import React, { useState, useEffect } from 'react';
import { Col, Row } from 'react-simple-flex-grid';

// components
import Button from '../../global/ButtonLink';
import { Heading1, Paragraph } from '../../global/Typography';
import { Wrapper, ContentWrapper, IllustrationWrapper, ButtonsWrapper } from './styled';

const messageTexts = {
    de:
        'Sie scheinen auf einer Seite gelandet zu sein, die es gar nicht gibt. Wir helfen Ihnen, wieder auf den richtigen Weg zu kommen. Wählen Sie einfach einen der untenstehenden Links:',
    en: 'Seem like you’ve landad on a page that does not exist. We’ll help you go back on track.',
};

const buttonTexts = {
    de: [{ label: 'Home', href: '/' }],
    en: [{ label: 'Go to homepage', href: '/' }],
};

function NotFoundPage() {
    const [lng, setLng] = useState('en');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setLng(window.location.pathname.slice(1, 3));
        }
    }, []);

    return (
        <Wrapper>
            <Row>
                <Col xs={12} md={6}>
                    <ContentWrapper>
                        <Heading1>404 Error!</Heading1>
                        <Paragraph>{messageTexts[lng]}</Paragraph>
                        <ButtonsWrapper>
                            <Button
                                href={buttonTexts[lng][0].href}
                                label={buttonTexts[lng][0].label}
                                lng={lng}
                                transparent
                            />
                        </ButtonsWrapper>
                    </ContentWrapper>
                </Col>
                <Col xs={12} md={6}>
                    <IllustrationWrapper>
                        <svg
                            width="469px"
                            height="342px"
                            viewBox="0 0 469 342"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                        >
                            <defs>
                                <path
                                    d="M116,84 L216,84 C219.865993,84 223,87.1340068 223,91 L223,189 C223,192.865993 219.865993,196 216,196 L116,196 C112.134007,196 109,192.865993 109,189 L109,91 C109,87.1340068 112.134007,84 116,84 Z"
                                    id="path-1"
                                />
                                <mask
                                    id="mask-2"
                                    maskContentUnits="userSpaceOnUse"
                                    maskUnits="objectBoundingBox"
                                    x="0"
                                    y="0"
                                    width="114"
                                    height="112"
                                    fill="white"
                                >
                                    <use xlinkHref="#path-1" />
                                </mask>
                                <path
                                    d="M11,84 L98,84 C101.865993,84 105,87.1340068 105,91 L105,189 C105,192.865993 101.865993,196 98,196 L11,196 C7.13400675,196 4,192.865993 4,189 L4,91 C4,87.1340068 7.13400675,84 11,84 Z"
                                    id="path-3"
                                />
                                <mask
                                    id="mask-4"
                                    maskContentUnits="userSpaceOnUse"
                                    maskUnits="objectBoundingBox"
                                    x="0"
                                    y="0"
                                    width="101"
                                    height="112"
                                    fill="white"
                                >
                                    <use xlinkHref="#path-3" />
                                </mask>
                                <path
                                    d="M234,84 L365,84 C368.865993,84 372,87.1340068 372,91 L372,129 C372,132.865993 368.865993,136 365,136 L234,136 C230.134007,136 227,132.865993 227,129 L227,91 C227,87.1340068 230.134007,84 234,84 Z"
                                    id="path-5"
                                />
                                <mask
                                    id="mask-6"
                                    maskContentUnits="userSpaceOnUse"
                                    maskUnits="objectBoundingBox"
                                    x="0"
                                    y="0"
                                    width="145"
                                    height="52"
                                    fill="white"
                                >
                                    <use xlinkHref="#path-5" />
                                </mask>
                                <path
                                    d="M234,140 L365,140 C368.865993,140 372,143.134007 372,147 L372,236 C372,239.865993 368.865993,243 365,243 L234,243 C230.134007,243 227,239.865993 227,236 L227,147 C227,143.134007 230.134007,140 234,140 Z"
                                    id="path-7"
                                />
                                <mask
                                    id="mask-8"
                                    maskContentUnits="userSpaceOnUse"
                                    maskUnits="objectBoundingBox"
                                    x="0"
                                    y="0"
                                    width="145"
                                    height="103"
                                    fill="white"
                                >
                                    <use xlinkHref="#path-7" />
                                </mask>
                                <path
                                    d="M234,247 L365,247 C368.865993,247 372,250.134007 372,254 L372,275 C372,286.59798 362.59798,296 351,296 L234,296 C230.134007,296 227,292.865993 227,289 L227,254 C227,250.134007 230.134007,247 234,247 Z"
                                    id="path-9"
                                />
                                <mask
                                    id="mask-10"
                                    maskContentUnits="userSpaceOnUse"
                                    maskUnits="objectBoundingBox"
                                    x="0"
                                    y="0"
                                    width="145"
                                    height="49"
                                    fill="white"
                                >
                                    <use xlinkHref="#path-9" />
                                </mask>
                                <path
                                    d="M11,199 L216,199 C219.865993,199 223,202.134007 223,206 L223,289 C223,292.865993 219.865993,296 216,296 L25,296 C13.4020203,296 4,286.59798 4,275 L4,206 C4,202.134007 7.13400675,199 11,199 Z"
                                    id="path-11"
                                />
                                <mask
                                    id="mask-12"
                                    maskContentUnits="userSpaceOnUse"
                                    maskUnits="objectBoundingBox"
                                    x="0"
                                    y="0"
                                    width="219"
                                    height="97"
                                    fill="white"
                                >
                                    <use xlinkHref="#path-11" />
                                </mask>
                                <path
                                    d="M25,4 L351,4 C362.59798,4 372,13.4020203 372,25 L372,74 C372,77.8659932 368.865993,81 365,81 L11,81 C7.13400675,81 4,77.8659932 4,74 L4,25 C4,13.4020203 13.4020203,4 25,4 Z"
                                    id="path-13"
                                />
                                <mask
                                    id="mask-14"
                                    maskContentUnits="userSpaceOnUse"
                                    maskUnits="objectBoundingBox"
                                    x="0"
                                    y="0"
                                    width="368"
                                    height="77"
                                    fill="white"
                                >
                                    <use xlinkHref="#path-13" />
                                </mask>
                            </defs>
                            <g
                                id="Website-pages"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                            >
                                <g id="Error-Page" transform="translate(-736.000000, -144.000000)">
                                    <g
                                        id="current-performance"
                                        transform="translate(233.000000, 144.000000)"
                                    >
                                        <g
                                            id="error-illustration"
                                            transform="translate(503.000000, 0.000000)"
                                        >
                                            <g
                                                id="illustration"
                                                transform="translate(0.000000, 42.000000)"
                                            >
                                                <path
                                                    d="M352,1 C358.351275,1 364.101275,3.57436269 368.263456,7.73654403 C372.425637,11.8987254 375,17.6487254 375,24 L375,24 L375,276 C375,282.351275 372.425637,288.101275 368.263456,292.263456 C364.101275,296.425637 358.351275,299 352,299 L352,299 L24,299 C17.6487254,299 11.8987254,296.425637 7.73654403,292.263456 C3.57436269,288.101275 1,282.351275 1,276 L1,276 L1,24 C1,17.6487254 3.57436269,11.8987254 7.73654403,7.73654403 C11.8987254,3.57436269 17.6487254,1 24,1 L24,1 Z"
                                                    id="Rectangle"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                />
                                                <path
                                                    d="M2,179.008304 C17.719507,179.269539 31.9431081,185.678444 42.3706392,195.934911 C53.0368533,206.426145 59.7313651,220.943054 59.9919945,237.015891 L59.991,237 L2,237 Z"
                                                    id="Rectangle"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                />
                                                <path
                                                    d="M86,-16.5 C88.4852814,-16.5 90.7352814,-15.4926407 92.363961,-13.863961 C93.9926407,-12.2352814 95,-9.98528137 95,-7.5 L95,-7.5 L95,22.5 C95,24.9852814 93.9926407,27.2352814 92.363961,28.863961 C90.7352814,30.4926407 88.4852814,31.5 86,31.5 L86,31.5 L82,31.5 L82,-16.5 Z"
                                                    id="Rectangle-Copy-20"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                    transform="translate(88.500000, 7.500000) rotate(-270.000000) translate(-88.500000, -7.500000) "
                                                />
                                                <path
                                                    d="M152,-16.5 C154.485281,-16.5 156.735281,-15.4926407 158.363961,-13.863961 C159.992641,-12.2352814 161,-9.98528137 161,-7.5 L161,-7.5 L161,22.5 C161,24.9852814 159.992641,27.2352814 158.363961,28.863961 C156.735281,30.4926407 154.485281,31.5 152,31.5 L152,31.5 L148,31.5 L148,-16.5 Z"
                                                    id="Rectangle-Copy-21"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                    transform="translate(154.500000, 7.500000) rotate(-270.000000) translate(-154.500000, -7.500000) "
                                                />
                                                <path
                                                    d="M218,-16.5 C220.485281,-16.5 222.735281,-15.4926407 224.363961,-13.863961 C225.992641,-12.2352814 227,-9.98528137 227,-7.5 L227,-7.5 L227,22.5 C227,24.9852814 225.992641,27.2352814 224.363961,28.863961 C222.735281,30.4926407 220.485281,31.5 218,31.5 L218,31.5 L214,31.5 L214,-16.5 Z"
                                                    id="Rectangle-Copy-22"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                    transform="translate(220.500000, 7.500000) rotate(-270.000000) translate(-220.500000, -7.500000) "
                                                />
                                                <path
                                                    d="M284,-16.5 C286.485281,-16.5 288.735281,-15.4926407 290.363961,-13.863961 C291.992641,-12.2352814 293,-9.98528137 293,-7.5 L293,-7.5 L293,22.5 C293,24.9852814 291.992641,27.2352814 290.363961,28.863961 C288.735281,30.4926407 286.485281,31.5 284,31.5 L284,31.5 L280,31.5 L280,-16.5 Z"
                                                    id="Rectangle-Copy-23"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                    transform="translate(286.500000, 7.500000) rotate(-270.000000) translate(-286.500000, -7.500000) "
                                                />
                                                <rect
                                                    id="Rectangle-Copy-18"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                    transform="translate(292.000000, 248.000000) rotate(90.000000) translate(-292.000000, -248.000000) "
                                                    x="277"
                                                    y="189"
                                                    width="30"
                                                    height="118"
                                                    rx="8"
                                                />
                                                <rect
                                                    id="Rectangle-Copy-26"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                    transform="translate(262.000000, 140.000000) rotate(90.000000) translate(-262.000000, -140.000000) "
                                                    x="243"
                                                    y="85"
                                                    width="38"
                                                    height="110"
                                                    rx="8"
                                                />
                                                <rect
                                                    id="Rectangle-Copy-27"
                                                    strokeOpacity="0.16"
                                                    stroke="#000000"
                                                    strokeWidth="2"
                                                    fill="#FFFFFF"
                                                    x="87"
                                                    y="85"
                                                    width="38"
                                                    height="110"
                                                    rx="8"
                                                />
                                                <use
                                                    id="Rectangle-Copy-28"
                                                    strokeOpacity="0.88"
                                                    stroke="#F24D68"
                                                    mask="url(#mask-2)"
                                                    strokeWidth="10"
                                                    fillOpacity="0.24"
                                                    fill="#F24D68"
                                                    strokeDasharray="15.2,12"
                                                    xlinkHref="#path-1"
                                                />
                                                <use
                                                    id="Rectangle-Copy-30"
                                                    strokeOpacity="0.5"
                                                    stroke="#3FA9F5"
                                                    mask="url(#mask-4)"
                                                    strokeWidth="4"
                                                    fillOpacity="0.08"
                                                    fill="#3FA9F5"
                                                    strokeDasharray="8,4"
                                                    xlinkHref="#path-3"
                                                />
                                                <use
                                                    id="Rectangle-Copy-32"
                                                    strokeOpacity="0.5"
                                                    stroke="#3FA9F5"
                                                    mask="url(#mask-6)"
                                                    strokeWidth="4"
                                                    fillOpacity="0.08"
                                                    fill="#3FA9F5"
                                                    strokeDasharray="8,4"
                                                    xlinkHref="#path-5"
                                                />
                                                <use
                                                    id="Rectangle-Copy-33"
                                                    strokeOpacity="0.5"
                                                    stroke="#3FA9F5"
                                                    mask="url(#mask-8)"
                                                    strokeWidth="4"
                                                    fillOpacity="0.08"
                                                    fill="#3FA9F5"
                                                    strokeDasharray="8,4"
                                                    xlinkHref="#path-7"
                                                />
                                                <use
                                                    id="Rectangle-Copy-35"
                                                    strokeOpacity="0.5"
                                                    stroke="#3FA9F5"
                                                    mask="url(#mask-10)"
                                                    strokeWidth="4"
                                                    fillOpacity="0.08"
                                                    fill="#3FA9F5"
                                                    strokeDasharray="8,4"
                                                    xlinkHref="#path-9"
                                                />
                                                <use
                                                    id="Rectangle-Copy-34"
                                                    strokeOpacity="0.5"
                                                    stroke="#3FA9F5"
                                                    mask="url(#mask-12)"
                                                    strokeWidth="4"
                                                    fillOpacity="0.08"
                                                    fill="#3FA9F5"
                                                    strokeDasharray="8,4"
                                                    xlinkHref="#path-11"
                                                />
                                                <use
                                                    id="Rectangle-Copy-31"
                                                    strokeOpacity="0.5"
                                                    stroke="#3FA9F5"
                                                    mask="url(#mask-14)"
                                                    strokeWidth="4"
                                                    fillOpacity="0.08"
                                                    fill="#3FA9F5"
                                                    strokeDasharray="8,4"
                                                    xlinkHref="#path-13"
                                                />
                                                <path
                                                    d="M165.16,143.72 L165.16,139.68 C168.013333,139.626667 170.286667,138.893333 171.98,137.48 C173.673333,136.066667 174.52,134.026667 174.52,131.36 C174.52,128.72 173.693333,126.68 172.04,125.24 C170.386667,123.8 168.2,123.08 165.48,123.08 C163.48,123.08 161.753333,123.446667 160.3,124.18 C158.846667,124.913333 157.746667,125.913333 157,127.18 C156.253333,128.446667 155.906667,129.88 155.96,131.48 L155.96,131.48 L161.28,131.48 C161.28,130.36 161.64,129.446667 162.36,128.74 C163.08,128.033333 164.053333,127.68 165.28,127.68 C166.4,127.68 167.293333,128.006667 167.96,128.66 C168.626667,129.313333 168.96,130.226667 168.96,131.4 C168.96,133.16 168.36,134.366667 167.16,135.02 C165.96,135.673333 164.28,136 162.12,136 L162.12,136 L159.84,136 L159.84,143.72 L165.16,143.72 Z M165.6,153 L165.6,147.12 L159.52,147.12 L159.52,153 L165.6,153 Z"
                                                    id="?"
                                                    fill="#F24D68"
                                                    fillRule="nonzero"
                                                />
                                            </g>
                                            <g
                                                id="Group-11"
                                                transform="translate(255.000000, 0.000000)"
                                            >
                                                <circle
                                                    id="Oval"
                                                    fill="#2393FF"
                                                    cx="107"
                                                    cy="107"
                                                    r="107"
                                                />
                                                <g
                                                    id="Group-12"
                                                    transform="translate(40.000000, 69.000000)"
                                                    fill="#FFFFFF"
                                                    fillRule="nonzero"
                                                >
                                                    <path
                                                        d="M50.22,93.5769231 L50.22,90.8649231 L43.5,90.8649231 L43.5,86.3049231 L49.5,86.3049231 L49.5,83.7129231 L43.5,83.7129231 L43.5,79.3209231 L50.22,79.3209231 L50.22,76.6329231 L40.116,76.6329231 L40.116,93.5769231 L50.22,93.5769231 Z M56.1,93.5769231 L56.1,87.1689231 C56.1,84.8649231 57.34,83.7129231 59.82,83.7129231 L59.82,83.7129231 L60.804,83.7129231 L60.804,80.0889231 C59.796,80.0889231 58.884,80.3329231 58.068,80.8209231 C57.252,81.3089231 56.596,81.9769231 56.1,82.8249231 L56.1,82.8249231 L56.1,80.2809231 L52.716,80.2809231 L52.716,93.5769231 L56.1,93.5769231 Z M66.06,93.5769231 L66.06,87.1689231 C66.06,84.8649231 67.3,83.7129231 69.78,83.7129231 L69.78,83.7129231 L70.764,83.7129231 L70.764,80.0889231 C69.756,80.0889231 68.844,80.3329231 68.028,80.8209231 C67.212,81.3089231 66.556,81.9769231 66.06,82.8249231 L66.06,82.8249231 L66.06,80.2809231 L62.676,80.2809231 L62.676,93.5769231 L66.06,93.5769231 Z M78.78,93.7449231 C80.076,93.7449231 81.24,93.4689231 82.272,92.9169231 C83.304,92.3649231 84.116,91.5769231 84.708,90.5529231 C85.3,89.5289231 85.596,88.3209231 85.596,86.9289231 C85.596,85.5369231 85.3,84.3249231 84.708,83.2929231 C84.116,82.2609231 83.304,81.4729231 82.272,80.9289231 C81.24,80.3849231 80.076,80.1129231 78.78,80.1129231 C77.484,80.1129231 76.32,80.3849231 75.288,80.9289231 C74.256,81.4729231 73.444,82.2609231 72.852,83.2929231 C72.26,84.3249231 71.964,85.5369231 71.964,86.9289231 C71.964,88.3209231 72.26,89.5289231 72.852,90.5529231 C73.444,91.5769231 74.256,92.3649231 75.288,92.9169231 C76.32,93.4689231 77.484,93.7449231 78.78,93.7449231 Z M78.78,90.8169231 C77.836,90.8169231 77.036,90.4849231 76.38,89.8209231 C75.724,89.1569231 75.396,88.1929231 75.396,86.9289231 C75.396,85.6649231 75.724,84.7009231 76.38,84.0369231 C77.036,83.3729231 77.836,83.0409231 78.78,83.0409231 C79.724,83.0409231 80.524,83.3729231 81.18,84.0369231 C81.836,84.7009231 82.164,85.6649231 82.164,86.9289231 C82.164,88.1929231 81.836,89.1569231 81.18,89.8209231 C80.524,90.4849231 79.724,90.8169231 78.78,90.8169231 Z M91.38,93.5769231 L91.38,87.1689231 C91.38,84.8649231 92.62,83.7129231 95.1,83.7129231 L95.1,83.7129231 L96.084,83.7129231 L96.084,80.0889231 C95.076,80.0889231 94.164,80.3329231 93.348,80.8209231 C92.532,81.3089231 91.876,81.9769231 91.38,82.8249231 L91.38,82.8249231 L91.38,80.2809231 L87.996,80.2809231 L87.996,93.5769231 L91.38,93.5769231 Z"
                                                        id="Error"
                                                    />
                                                    <path
                                                        d="M35.82,52.1923077 L35.82,41.9683077 L42.444,41.9683077 L42.444,33.1843077 L35.82,33.1843077 L35.82,0.784307692 L24.948,0.784307692 L0.612,33.5443077 L0.612,41.9683077 L25.596,41.9683077 L25.596,52.1923077 L35.82,52.1923077 Z M26.388,33.1843077 L10.98,33.1843077 L26.388,12.6643077 L26.388,33.1843077 Z M67.572,52.1923077 C74.436,52.1923077 79.38,49.8883077 82.404,45.2803077 C85.428,40.6723077 86.94,34.3603077 86.94,26.3443077 C86.94,18.3763077 85.428,12.0883077 82.404,7.48030769 C79.38,2.87230769 74.436,0.568307692 67.572,0.568307692 C54.612,0.568307692 48.132,9.16030769 48.132,26.3443077 C48.132,43.5763077 54.612,52.1923077 67.572,52.1923077 Z M67.572,42.6163077 C63.828,42.6163077 61.32,41.2123077 60.048,38.4043077 C58.776,35.5963077 58.14,31.5763077 58.14,26.3443077 C58.14,21.1603077 58.776,17.1643077 60.048,14.3563077 C61.32,11.5483077 63.828,10.1443077 67.572,10.1443077 C71.268,10.1443077 73.752,11.5483077 75.024,14.3563077 C76.296,17.1643077 76.932,21.1603077 76.932,26.3443077 C76.932,31.5763077 76.296,35.5963077 75.024,38.4043077 C73.752,41.2123077 71.268,42.6163077 67.572,42.6163077 Z M128.268,52.1923077 L128.268,41.9683077 L134.892,41.9683077 L134.892,33.1843077 L128.268,33.1843077 L128.268,0.784307692 L117.396,0.784307692 L93.06,33.5443077 L93.06,41.9683077 L118.044,41.9683077 L118.044,52.1923077 L128.268,52.1923077 Z M118.836,33.1843077 L103.428,33.1843077 L118.836,12.6643077 L118.836,33.1843077 Z"
                                                        id="404"
                                                    />
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </svg>
                    </IllustrationWrapper>
                </Col>
            </Row>
        </Wrapper>
    );
}

export default NotFoundPage;
